import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    ListItemText,
    FormControl,
    Input,
    InputLabel,
    Select
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { makeStyles } from "@mui/styles";
import { getProviderTypeAdminList } from "../../redux/actions/adminGetProviderTypeAction"
import { getAddIbanProviders } from "../../redux/actions/adminAddIbanProviderAction";
import { getProviderNamesAdminList } from "../../redux/actions/adminGetProviderNameAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import Util from "../../validation/index";
import { getProviderSList } from "../../redux/actions/getProvidersAdminAction";
import { adminCurrencyCode } from "../../redux/actions/adminCurrencyCodeAction";
import val from "../../getThemeDetails";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminIBNProviderMgmt = () => {
    const [provideTypeSearch, setProvideTypeSearch] = useState("");
    const [provideName, setProvideName] = useState("");
    const [provideTypes, setProvideTypes] = useState([]);
    const [addProvidersNames, setProvidersNames] = useState("");
    const [addProviderAlias, setAddProviderAlias] = useState("");
    const [addOpen, setAddOpen] = React.useState(false);
    const [currency, setCurrency] = useState("");

    const [selectedCurrency, setSelectedCurrency] = useState([]);
    const [languageList, setLanguageList] = useState([])
    const [selectedLanguage, setSelectedLanguage] = useState([]);



    const [addOrUpdateRoleStatus, setAddOrUpdateRoleStatus] = useState(false);
    const [addOrUpdateRoleResArray, setAddOrUpdateRoleResArray] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [transactionSubTypeList, settransactionSubTypeList] = useState([]);

    const [getProviderTypeStatus, setGetProviderTypeStatus] = useState(false);
    const [getProviderTypeResArray, setGetProviderTypeResArray] = useState([]);
    const [notificationOpen, setNotificationOpen] = React.useState(false);


    const [getProvidersStatus, setGetProvidersStatus] = useState(false);
    const [getProviderResArray, setGetProviderResArray] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();
    const getProviderTypeListRes = useSelector(({ adminGetProviderTypesLists }) => adminGetProviderTypesLists);
    const getAddIbanProvidersRes = useSelector(({ adminAddIBANProvidersLists }) => adminAddIBANProvidersLists);
    const getProviderNameListRes = useSelector(({ adminGetProvidersNamesLists }) => adminGetProvidersNamesLists);
    const adminCurrencyCodes = useSelector(({ adminCurrencyCode }) => adminCurrencyCode);
    console.log("currencyysss", adminCurrencyCodes)

    const getProviersListRes = useSelector(({ adminGetProvidersListS }) => adminGetProvidersListS);
    console.log("GetProviders", getProviersListRes);
    console.log("GetAddIbanProviders", getAddIbanProvidersRes);
    console.log("GetProviderTypes", getProviderTypeListRes);
    const [transactionSubTypesLists, getSetTransactionTypesLists] = useState(false)
    const [getTransactionSubTypeListResArray, setGetTransactionSubTypeListResArray] =
        useState([]);

    const handleNoticationClose = () => {
        setNotificationOpen(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    //   const [user, setUser] = useState({
    //     provideTypeSearch: "",
    //     provideName: "",

    //   });

    //   const {
    //     provideTypeSearch,
    //     provideName,

    //   } = user;


    useEffect(() => {
        const adminCurrReq = {
            loginDetails: {
                adminId: regenerateTokenRes.data.partnerId
            }
        }
        dispatch(adminCurrencyCode(adminCurrReq, authToken));
    }, [authToken]);

    const handleClose = () => {
        // setEditOpen(false);
        // setViewOpen(false);
        setAddOpen(false);
        // setShowParentRole(false);
        // setUser({
        // 	roleId: "",
        // 	role: "",
        // 	userType: "",
        // 	storeRequired: "",
        // 	isWalletRequired: "",
        // 	geoMapping: "",
        // 	subRole: "",
        // 	parentRole: ""
        // });
    };
    const addRole = () => {
        setAddOpen(true);
        setProvidersNames("");
        setAddProviderAlias("");
    };
    const handleChange = ({ target: { name, value } }) => {
        // const alphanumericWithSpaceRegex = /^[a-zA-Z0-9\s]*$/;

        const alphanumericRegex = /^[a-zA-Z0-9\s]*$/;
        // if (name === "ProvideType") {
        //     setProvideType(value == "Select Provider Type" ? "" : value);
        // }
        if (name === "ProvideTypeSearch") {
            setProvideTypeSearch(value == "Select Provider Type" ? "" : value);
        }
        if (name === "ProvideName") {
            setProvideName(value == "Select Provider Name" ? "" : value);
        }
        if (name === "ProvideType") {
            setProvideTypes(value == "Select Provider Type" ? "" : value);
        }
        // if (name === "ProvideNames") {
        //     setProvidersNames(value);
        // }
        if (name === "ProvideNames") {
            if (value.length <= 50 && alphanumericRegex.test(value)) {
                setProvidersNames(value);
            }
        }
        if (name === "Alias") {
            if (value.length <= 10 && alphanumericRegex.test(value)) {
                setAddProviderAlias(value);
            }
        }
        // if (name === "Alias") {
        //     setAddProviderAlias(value);
        // }
        if (name === "Currency") {
            setCurrency(value);
        }


    };


    const getProviderTypeStatusFunc = () => {
        if (getProviderTypeStatus) {
            if (getProviderTypeListRes.data.status == "success") {
                setGetProviderTypeResArray([].concat(getProviderTypeListRes.data.providerType));
            }
            if (getProviderTypeListRes.data.status == "failed") {
                setGetProviderTypeResArray(getProviderTypeListRes.data);
                if (
                    getProviderTypeListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderTypeListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getProviderTypeStatusFunc();
    }, [getProviderTypeListRes.data.status]);

    const getProviderTypeReq = () => {
        setGetProviderTypeStatus(true);
        dispatch(
            getProviderTypeAdminList(
                {
                    actionCustomerMasterRequestVO: {
                        // adminId: 2,
                        adminId: val.adminIDS


                    }
                },
                authToken
            )
        );
    };
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getProviderTypeReq();

        }
    }, [regenerateTokenRes.data.status]);



    const getTransactionSubTypeListFunc = () => {
        if (transactionSubTypesLists && getProviderNameListRes.data) {
            if (getProviderNameListRes.data.status == "success") {
                //console.log("subtypesssss", getTransactionSubTypesRes.data.transactionSubtype)
                setGetTransactionSubTypeListResArray(
                    getProviderNameListRes.data.providerNames
                );
            }
            if (getProviderNameListRes.data.status == "Failed") {
                setGetTransactionSubTypeListResArray(getProviderNameListRes.data);
                NotificationPopups(
                    "error",
                    "Failed",
                    getProviderNameListRes.data.description
                );
                if (
                    getProviderNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getProviderNameListRes.data.status == "failed") {
                setGetTransactionSubTypeListResArray(getProviderNameListRes.data);
                NotificationPopups(
                    "error",
                    "Failed",
                    getProviderNameListRes.data.description
                );
                if (
                    getProviderNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getProviderNameListRes.data.status == "NOT FOUND") {
                let transactionSubtype = [getProviderNameListRes.data.status]
                setGetTransactionSubTypeListResArray(transactionSubtype);
                // NotificationPopups(
                // 	"error",
                // 	"Failed",
                // 	getTransactionSubTypesRes.data.description
                // );
                if (
                    getProviderNameListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviderNameListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }

    };

    const getTransactionSubTypeListReqApi = () => {
        getSetTransactionTypesLists(true)
        const getTransactionSubTypeListReq = {
            actionCustomerMasterRequestVO: {
                // adminId: 2,
                adminId: val.adminIDS,

                providerType: provideTypeSearch
            }
        };

        return dispatch(
            getProviderNamesAdminList(getTransactionSubTypeListReq, authToken)
        );
    };
    useEffect(() => {
        getTransactionSubTypeListFunc();
    }, [getProviderNameListRes]);
    useEffect(() => {
        if (provideTypeSearch) {
            getTransactionSubTypeListReqApi()
        }
    }, [provideTypeSearch])

    const addIbanProviderReq = () => {
        setAddOpen(false);

        setAddOrUpdateRoleStatus(true);
        const addOrUpdateRoleReq = {
            actionCustomerMasterRequestVO: {
                // adminId: 2,
                adminId: val.adminIDS,

                providerType: provideTypes,
                providerName: addProvidersNames,
                providerAlias: addProviderAlias,
                currency: currency
            }

        };
        dispatch(getAddIbanProviders(addOrUpdateRoleReq, authToken));
    };

    const addOrUpdateRoleStatusFunc = () => {
        if (addOrUpdateRoleStatus) {
            if (getAddIbanProvidersRes.data.status == "success") {
                setAddOrUpdateRoleResArray(getAddIbanProvidersRes.data);
                setNotificationOpen(true);
                // getRoleListV1Req();
                // getRoleListReq();
            }
            if (getAddIbanProvidersRes.data.status == "failed") {
                setAddOrUpdateRoleResArray(getAddIbanProvidersRes.data);
                setNotificationOpen(true);
                if (
                    getAddIbanProvidersRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getAddIbanProvidersRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        addOrUpdateRoleStatusFunc();
    }, [getAddIbanProvidersRes.data.status]);


    const getProvidersReq = () => {
        setGetProvidersStatus(true);
        setIsLoading(true);
        dispatch(
            getProviderSList(
                {
                    actionCustomerMasterRequestVO: {
                        // adminId: 2,
                        adminId: val.adminIDS,

                        providerType: provideTypeSearch,
                        providerName: provideName
                    }
                },
                authToken
            )
        );
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getProvidersReq();

        }
    }, [regenerateTokenRes.data.status]);


    const getProvidersStatusFunc = () => {
        if (getProvidersStatus) {
            if (getProviersListRes.data.status == "success") {
                setGetProviderResArray([].concat(getProviersListRes.data.ibanProviderList));
                setIsLoading(false);
            }
            if (getProviersListRes.data.status == "Failed") {
                setGetProviderResArray(getProviersListRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "Failed",
                    getProviersListRes.data.description || getProviersListRes.description
                );
                if (
                    getProviersListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getProviersListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getProviersListRes.data.status == "NOT FOUND") {
                setGetProviderResArray(getProviersListRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "NOT FOUND",
                    getProviersListRes.data.description || getProviersListRes.description
                );
            }
            if (getProviersListRes.data.status == "INVALID REQUEST") {
                setGetProviderResArray(getProviersListRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "INVALID REQUEST",
                    getProviersListRes.data.description || getProviersListRes.description
                );
            }
        }
    };

    useEffect(() => {
        getProvidersStatusFunc();
    }, [getProviersListRes.data.status]);


    // Validation function for "Save" button
    const isSaveButtonEnabled = () => {
        // All required fields must be non-empty
        // For multi-select currency, check if the array has at least one item
        return (
            provideTypes !== "" &&
            addProvidersNames.trim() !== "" && // Trim to account for only spaces
            addProviderAlias.trim() !== "" &&
            currency.length > 0
        );
    };
    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px"
                        }}
                    >
                        <Grid item xs={12} md={5} sm={3} lg={7}></Grid>
                        <Grid item xs={12} md={3} sm={3} lg={2}>

                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={() => addRole()}

                            >
                                Add Provider
                            </CustomButton>
                        </Grid>

                        <Grid item xs={12} md={3} sm={3} lg={2}>
                            <NavLink to="/index/ibn-mapping-management">
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                // onClick={() => addRole()}

                                >
                                    Mapping Provider
                                </CustomButton>

                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Provider Type"
                                fullWidth={true}
                                variant="standard"
                                name="ProvideTypeSearch"
                                // value={roleSearch || "Select Role"}
                                defaultValue={"Select Provider Type" || provideTypeSearch}
                                onChange={handleChange}

                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Select Provider Type" selected="Select Provider Type">
                                    Select Provider Type
                                </MenuItem>
                                {getProviderTypeListRes.data?.providerType && // Added optional chaining
                                    getProviderTypeResArray.map((x, index) => ( // Added index for key
                                        <MenuItem key={index} value={x}>{x}</MenuItem>
                                    ))}
                                {/* {getProviderTypeListRes.data.providerType &&
                                    getProviderTypeResArray.map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))} */}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Provider Name"
                                fullWidth={true}
                                variant="standard"
                                name="ProvideName"
                                // value={roleSearch || "Select Role"}
                                defaultValue={"Select Provider Name" || provideName}
                                onChange={handleChange}

                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Select Provider Name" selected="Select Provider Name">
                                    Select Provider Name
                                </MenuItem>



                                {Array.isArray(getTransactionSubTypeListResArray) && getTransactionSubTypeListResArray.length > 0 ?
                                    getTransactionSubTypeListResArray.map((c, index) => (
                                        <MenuItem value={c} key={index}>
                                            {c}
                                        </MenuItem>
                                    )) : (
                                        <MenuItem disabled>No Data</MenuItem>
                                    )}

                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={getProvidersReq}

                            >
                                Search <SearchIcon />
                            </CustomButton>
                            {/* <Button
                                    style={{
                                        marginLeft: "0.7rem",
                                        backgroundColor: "#00b9f5",
                                        color: "white",
                                        marginTop: "9px"
                                    }}
                                    endIcon={<AiOutlineSearch />}
                                    variant="contained"
                                    onClick={getRoleListV1Req}
                                >
                                    Search
                                </Button> */}
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getProviderResArray.length == undefined ||
                    getProviderResArray.status == "NOT FOUND" ||
                    getProviderResArray.status == "INVALID REQUEST" ||
                    !getProvidersStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                // style={{ backgroundColor: "#00b9f5", color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">

                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Provider Type
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Provider Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Provider Alias
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {getProviderResArray &&
                                            []
                                                .concat(getProviderResArray)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow>
                                                        <TableCell align="center">{row.providerType}</TableCell>
                                                        <TableCell align="center">{row.providerName}</TableCell>
                                                        <TableCell align="center">{row.providerAlias}</TableCell>


                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getProviderResArray.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}

                <div>
                    <Dialog open={addOpen} onClose={handleClose}>
                        <DialogTitle style={{ minWidth: "600px" }}>Add Provider</DialogTitle>
                        <DialogContent>
                            <TextField
                                select

                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Provider Types"
                                fullWidth={true}
                                name="ProvideType"
                                defaultValue={"Select Provider Type" || provideTypes}


                                variant="standard"
                                onChange={handleChange}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >

                                <MenuItem value="Select Provider Type" selected="Select Provider Type">
                                    Select Provider Type
                                </MenuItem>
                                {getProviderTypeListRes.data?.providerType && // Added optional chaining
                                    getProviderTypeResArray.map((x, index) => ( // Added index for key
                                        <MenuItem key={index} value={x}>{x}</MenuItem>
                                    ))}
                            </TextField>

                            <TextField
                                required
                                style={{ marginTop: "10px" }}

                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Provider Name"
                                fullWidth={true}
                                variant="standard"

                                name="ProvideNames"
                                value={addProvidersNames || ""}
                                // onChange={(e) => onInputChange(e)}
                                onChange={handleChange}
                                inputProps={{ maxLength: 25 }} // Limit to 10 characters
                            >

                            </TextField>

                            <TextField
                                required
                                style={{ marginTop: "10px" }}

                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Provider Alias Name"
                                fullWidth={true}
                                variant="standard"

                                name="Alias"
                                value={addProviderAlias || ""}
                                onChange={handleChange}
                                inputProps={{ maxLength: 10 }} // Limit to 10 characters
                            >

                            </TextField>

                            {/* <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Currency"
                                fullWidth={true}
                                variant="standard"

                                name="Currency"
                                value={currency || "Select Currency"}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Currency" selected="Select Currency">
                                    Select Currency
                                </MenuItem>
                                {adminCurrencyCodes.success &&
                                    []
                                        .concat(adminCurrencyCodes.data.currencyList)
                                        .map((x) => <MenuItem value={x.substring(x.indexOf('-') + 1)}>{x.substring(x.indexOf('-') + 1)}</MenuItem>)}
                            </TextField> */}

                            <FormControl fullWidth variant="standard" sx={{ mt: 2 }}>
                                <InputLabel id="currency-multi-select-label">Currency</InputLabel>
                                <Select
                                    labelId="currency-multi-select-label"
                                    multiple
                                    value={Array.isArray(currency) ? currency : []}
                                    onChange={(event) => {
                                        const value = event.target.value;
                                        const allCurrencies = adminCurrencyCodes.data?.currencyList?.map((c) => c.substring(c.indexOf('-') + 1)) || [];
                                        if (value.includes('all')) {
                                            if (currency.length === allCurrencies.length) {
                                                setCurrency([]);
                                            } else {
                                                setCurrency(allCurrencies);
                                            }
                                        } else {
                                            setCurrency(value);
                                        }
                                    }}
                                    input={<Input />}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    <MenuItem value="all">
                                        <Checkbox
                                            checked={
                                                currency.length > 0 &&
                                                currency.length === (adminCurrencyCodes.data?.currencyList?.length || 0)
                                            }
                                        />
                                        <ListItemText primary="Select All" />
                                    </MenuItem>
                                    {adminCurrencyCodes.success &&
                                        adminCurrencyCodes.data?.currencyList?.map((c) => {
                                            const val = c.substring(c.indexOf('-') + 1);
                                            return (
                                                <MenuItem key={val} value={val}>
                                                    <Checkbox checked={currency.indexOf(val) > -1} />
                                                    <ListItemText primary={val} />
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </FormControl>



                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={addIbanProviderReq}
                                disabled={!isSaveButtonEnabled()}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            </Layout>

            {addOrUpdateRoleResArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addOrUpdateRoleResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addOrUpdateRoleResArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addOrUpdateRoleResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminIBNProviderMgmt